import React from 'react';

export const PageCopy = () => (
  <div>
    <div className='membership-item__segment--text-content'>
      <p>
        The JD-800 Software Synthesizer is painstakingly crafted to sound and
        behave exactly like the original hardware. Rather than simply a bunch of
        JD-800 samples, we used the original waveform data along with advanced
        modeling techniques to perfectly recreate the big, bright, spacious sound
        that only the JD-800 can deliver.
      </p>
      <ul>
        <li>
          Authentic sound and behavior with advanced modeling and original JD-800
          waveforms
        </li>
        <li>
          64 presets from the original JD-800, plus 64 new presets crafted by top
          sound designers
        </li>
        <li>
          Detailed recreation of the JD-800’s two-stage multi-effects section with
          drag and drop reordering
        </li>
        <li>
          Seven effects including chorus, phaser, enhancer, distortion, spectrum,
          delay, and reverb
        </li>
        <li>
          Detailed, realistic interface that’s resizable and includes alternate
          views
        </li>
        <li>Expanded polyphony versus the original hardware</li>
        <li>VST3, AAX, and AU with support for Apple silicon</li>
      </ul>
    </div>
    <iframe
      width='100%'
      className='roland-soundcloud'
      height='450'
      scrolling='no'
      frameBorder='no'
      allow='autoplay'
      src='https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1334173171%3Fsecret_token%3Ds-dslOOLMqomA&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false'
      title='sound-cloud'
    />
    <div
      style={{
        fontSize: 10,
        color: 'rgb(51, 51, 51)',
        lineBreak: 'anywhere',
        wordBreak: 'normal',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        fontFamily:
          'Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif',
        fontWeight: 100,
      }}
    >
      <div>
        <a
          href='https://soundcloud.com/rolandcom'
          title='Roland Corporation'
          target='_blank'
          style={{ color: 'rgb(51, 51, 51)', textDecoration: 'none' }}
          rel='noreferrer'
        >
          Roland Corporation
        </a>
        <a
          href='https://soundcloud.com/rolandcom/sets/jd-800-software-demo-song-sound-demos/s-dslOOLMqomA'
          title='JD-800 Software Demo Song & Sound Demos'
          target='_blank'
          style={{ color: 'rgb(51, 51, 51), text-decoration: none' }}
          rel='noreferrer'
        >
          JD-800 Software Demo Song &amp; Sound Demos
        </a>
      </div>
    </div>
  </div>
);
